import {
  normalizeBooleanFlag,
  normalizeOilChangeState,
} from "../../../utils/receiptCalculations";

// Utility to prefill the AddReceipts form from an existing receipt/estimate
export const hydrateFromReceipt = ({
  data,
  serviceOptions = [],
  rawTires = [],
  oilsOptions = [],
  statusOptions = [],
  paymentTypeOptions = [],
  computeTotals,
  setSelectedCustomer,
  setSelectedVehicle,
  setSelectedServices,
  setSelectedTireOptions,
  setSelectedOil,
  setselectedStatus,
  setSelectedPaymentType,
  setReceipt,
  setIsEditing,
  setLoadedEditPrefill,
}) => {
  if (!data) return;
  const incomingType = data.receiptType || data.type || "Quote";
  const normalizedTaxIncluded =
    normalizeBooleanFlag(
      typeof data.taxIncluded !== "undefined"
        ? data.taxIncluded
        : data.taxInclude,
    ) ||
    Number(data.tax) > 0 ||
    (typeof data.taxIncluded === "undefined" && typeof data.taxInclude === "undefined" && data.customer?.tax === "Taxable");
  const normalizedDiscountIncluded =
    normalizeBooleanFlag(
      typeof data.discountIncluded !== "undefined"
        ? data.discountIncluded
        : data.discountInclude,
    ) || Number(data.discountAmount || data.discount) > 0;

  const customerOption = data.customer
    ? {
        label: `${data.customer.name || ""}${
          data.customer.phone ? ` (${data.customer.phone})` : ""
        }`,
        value: data.customer,
      }
    : null;

  const vehicleOption = data.vehicle
    ? {
        label: `${data.vehicle.make || data.vehicle.make || ""} ${
          data.vehicle.model || ""
        }`.trim(),
        value: data.vehicle,
      }
    : "";

  const serviceOptionFor = (svc) => {
    const value = svc?.value ?? svc ?? {};
    const valueId = value?._id || value?.id;
    const match = serviceOptions.find(
      (opt) => (opt?.value?._id || opt?.value?.id) === valueId
    );
    if (match) return { ...match, value: { ...match.value, ...value } };
    return {
      label: value.name || value.service_name || value.type || "Service",
      value,
    };
  };

  const selectedSvcOpts = Array.isArray(data.services)
    ? data.services.map(serviceOptionFor)
    : [];

  const tireOptionFor = (t) => {
    const value = t?.value ?? t ?? {};
    const valueId = value?._id || value?.id;
    const match = rawTires.find(
      (opt) => (opt?.value?._id || opt?.value?.id) === valueId
    );
    if (match) return match;
    return {
      label: `${value.condition || "Used"} - ${value.brand || ""} ${
        value.size || ""
      } $${value.price || 0} Qty: ${value.quantity || 0}`,
      value,
    };
  };

  const selectedTireOpts = Array.isArray(data.tires)
    ? data.tires.map(tireOptionFor)
    : [];

  const oilOption =
    data.oil && data.oil._id
      ? oilsOptions.find(
          (opt) =>
            (opt?.value?._id || opt?.value?.id) ===
            (data.oil._id || data.oil.id)
        ) || {
          label: `${data.oil.brand || ""} ${data.oil.name || ""}`.trim(),
          value: data.oil,
        }
      : data.oil
      ? {
          label: `${data.oil.brand || ""} ${data.oil.name || ""}`.trim(),
          value: data.oil,
        }
      : "";

  const statusOpt = statusOptions.find((o) => o.value === data.status) || "";
  const paymentTypeOpt =
    paymentTypeOptions.find((o) => o.value === data.paymentType) || "";

  const normalizedData = normalizeOilChangeState(data);
  const { services, tires, subtotal, discountAmount, tax, totalPrice, remaining } =
    computeTotals({
      services: selectedSvcOpts,
      tires: selectedTireOpts.map((t) => t.value ?? t),
      oilPrice: normalizedData.oilPrice,
      extraOilPrice: normalizedData.extraOilPrice,
      oilFilterPrice: normalizedData.oilFilterPrice,
      fullServiceIncluded: normalizedData.fullServiceIncluded,
      fullServicePrice: normalizedData.fullServicePrice,
      taxIncluded: normalizedTaxIncluded,
      taxPct: normalizedData.taxType,
      discountIncluded: normalizedDiscountIncluded,
      discountType: normalizedData.discountType,
      discount: normalizedData.discount,
      paid: normalizedData.paid,
    });

  setSelectedCustomer(customerOption);
  setSelectedVehicle(vehicleOption);
  setSelectedServices(selectedSvcOpts);
  setSelectedTireOptions(selectedTireOpts);
  setSelectedOil(oilOption);
  setselectedStatus(statusOpt);
  setSelectedPaymentType(paymentTypeOpt);

  setReceipt((prev) => ({
    ...prev,
    ...normalizedData,
    taxIncluded: normalizedTaxIncluded,
    discountIncluded: normalizedDiscountIncluded,
    receiptType: incomingType,
    date: normalizedData.date ? normalizedData.date.toString().slice(0, 10) : prev.date,
    services,
    tires,
    subTotal: subtotal.toFixed(2),
    discountAmount: discountAmount.toFixed(2),
    tax: tax.toFixed(2),
    totalPrice: totalPrice.toFixed(2),
    remaining: remaining.toFixed(2),
  }));

  setIsEditing(true);
  setLoadedEditPrefill(true);
};
